export interface FaqQuestion {
  question: string
  answer: string
}

export const faqPageJsonLd = (questions: readonly FaqQuestion[]) => {
  if (!questions.length) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: { '@type': 'Answer', text: answer },
    })),
  }
}
